// extracted by mini-css-extract-plugin
module.exports = {"polygonFormItem":"polygonFormItem_rbBgD"};